import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { getRequest, postRequest, deleteRequest } from 'utils/http'

// GET all blog posts with pagination

const getBlogPosts = async (current, pageSize) => {
  return getRequest('blog_posts', {
    params: {
      page: current,

      pageSize: pageSize,
    },
  })
}

export function useGetBlogPosts (current, pageSize) {
  return useQuery({
    queryKey: ['blog_posts', current, pageSize],

    queryFn: () => getBlogPosts(current, pageSize),
  })
}

// POST a new blog post

const createBlogPost = async newBlogPostData => {
  return postRequest('blog_posts', newBlogPostData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

export function useCreateBlogPost () {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: createBlogPost,
    onSuccess: () => {
      queryClient.invalidateQueries('blog_posts')
    },
  })
}

const updateBlogPost = async updatedBlogPostData => {
  // Use postRequest, but the FormData object will contain the _method field.
  return postRequest(
    `blog_posts/${updatedBlogPostData.get('id')}`, // The URL still needs the ID
    updatedBlogPostData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  )
}

export function useUpdateBlogPost () {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: updateBlogPost,

    onSuccess: () => {
      queryClient.invalidateQueries('blog_posts')
    },
  })
}

// DELETE a blog post

const deleteBlogPost = async id => {
  return deleteRequest(`blog_posts/${id}`)
}

export function useDeleteBlogPost () {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: deleteBlogPost,

    onSuccess: () => {
      queryClient.invalidateQueries('blog_posts')
    },
  })
}
